import React, {
  PropTypes as T,
  Component,
} from 'react';
import radium from 'radium';
import * as ReservationActions from '../../actions/Reservation.js';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Calendar from '../../libs/Calendar.js';
import DatePicker from 'rc-calendar/lib/Picker';
import moment from 'moment';

import ReservationDetailMap from './ReservationDetailMap.js';

const styles = {
  wrap: {
    display: 'none',
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, .38)',
  },
  shown: {
    display: 'block',
  },
  container: {
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    overflow: 'auto',
  },
  form: {
    width: 350,
    backgroundColor: '#eee',
    position: 'relative',
    overflow: 'auto',
    marginBottom: 90,
    marginTop: 90,
    borderRadius: 10,
    paddingBottom: 53,
    '@media (max-width: 767px)': {
      width: '100%',
      height: '100%',
    },
  },
  contentWrap: {
    padding: 20,
  },
  title: {
    display: 'block',
    fontSize: 18,
    border: '1px dashed #ccc',
    padding: '15px 20px 5px 20px',
    fontWeight: 'bold',
  },
  listWrap: {
    margin: 0,
    padding: '0 0 0 2em',
    maxHeight: 300,
    overflow: 'auto',
  },
  listItem: {
    listStyle: 'none',
    lineHeight: 2,
    color: '#4a4a4a',
    fontWeight: 300,
    letterSpacing: 1,
    position: 'relative',
    '@media (max-width: 767px)': {
      lineHeight: 1.5,
    },
  },
  listIndex: {
    fontSize: 14,
    textAlign: 'center',
  },
  bottomWrap: {
    width: '100%',
    textAlign: 'center',
    position: 'absolute',
    bottom: 0,
    lineHeight: '52px',
    padding: 0,
    textDecoration: 'none',
    color: '#4A4A4A',
    borderTop: '1px solid #D8D8D8',
    letterSpacing: 1.5,
    fontSize: 24,
    backgroundColor: 'transparent',
    borderLeft: 0,
    borderRight: 0,
    borderBottom: 0,
    cursor: 'pointer',
  },
  h1: {
    position: 'relative',
    backgroundColor: '#fed312',
    margin: 0,
    color: 'white',
    fontSize: 24,
    lineHeight: '42px',
    textAlign: 'center',
    letterSpacing: 2,
  },
  text: {
    outline: 'none',
    border: 0,
    backgroundColor: 'transparent',
    fontSize: 15,
    lineHeight: 1.5,
    display: 'block',
  },
  closeBtn: {
    position: 'absolute',
    right: 10,
    color: 'white',
    backgroundColor: 'transparent',
    border: 0,
    outline: 'none',
    lineHeight: '42px',
    padding: 0,
    fontSize: 24,
    cursor: 'pointer',
  },
  timeLine: {
    display: 'flex',
    alignItems: 'center',
  },
  timeLabel: {
    margin: '0px 10px 0px 0px',
  },
};

class ReservationFormModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      date: null,
    };
  }

  sendRequest() {
    const {
      createReservation,
      shop,
      customerId,
    } = this.props;
    if (!this.state.date || !this.state.date.isValid()) {
      alert('請選擇預約日期，或日期格式錯誤');
      return;
    }

    createReservation(customerId, shop.id, this.state.date);
  }

  render() {
    const {
      isFormModalOpen,
      closeReservationModal,
      shop,
    } = this.props;

    const {
      date,
    } = this.state;

    if (!shop) return null;
    return (
      <div style={[styles.wrap, isFormModalOpen && styles.shown]}>
        <div style={styles.container}>
          <div style={styles.form}>
            <h1 style={styles.h1}>
              預約來店
              <button onClick={() => closeReservationModal()} className="fa fa-times" style={styles.closeBtn} />
            </h1>
            <span style={styles.title}>{shop.name}</span>
            <div style={styles.contentWrap}>
              <label htmlFor="date" style={styles.label}>請選擇預約日期：</label>
              <DatePicker
                animation="slide-up"
                calendar={Calendar}
                value={date}
                children={({ value }) => (
                  <input
                    style={styles.input}
                    placeholder="預約日期"
                    readOnly
                    tabIndex="-1"
                    className="ant-calendar-picker-input ant-input"
                    value={value && moment(value).format('YYYY-MM-DD') || ''} />
                )}
                onChange={(d) => {
                  if (moment().diff(d, 'days') < -1) {
                    this.setState({ date: d });
                  } else {
                    alert('日期請至少提前三天預約');
                    this.setState({ date: null });
                  }
                }} />
            </div>
            <div style={styles.contentWrap}>
              <span style={styles.text}>{shop.tel}</span>
              <span style={styles.text}>{shop.addr}</span>
              <div style={styles.timeWrap}>
                <span style={styles.text}>營業時間</span>
                {shop.moA && <div style={styles.timeLine}>
                  <label style={styles.timeLabel}>週一</label>
                  <span style={styles.text}>{shop.moA} {shop.moB}</span>
                </div>}
                {shop.tuA && <div style={styles.timeLine}>
                  <label style={styles.timeLabel}>週二</label>
                  <span style={styles.text}>{shop.tuA} {shop.tuB}</span>
                </div>}
                {shop.weA && <div style={styles.timeLine}>
                  <label style={styles.timeLabel}>週三</label>
                  <span style={styles.text}>{shop.weA} {shop.weB}</span>
                </div>}
                {shop.thA && <div style={styles.timeLine}>
                  <label style={styles.timeLabel}>週四</label>
                  <span style={styles.text}>{shop.thA} {shop.thB}</span>
                </div>}
                {shop.frA && <div style={styles.timeLine}>
                  <label style={styles.timeLabel}>週五</label>
                  <span style={styles.text}>{shop.frA} {shop.frB}</span>
                </div>}
                {shop.saA && <div style={styles.timeLine}>
                  <label style={styles.timeLabel}>週六</label>
                  <span style={styles.text}>{shop.saA} {shop.saB}</span>
                </div>}
                {shop.suA && <div style={styles.timeLine}>
                  <label style={styles.timeLabel}>週日</label>
                  <span style={styles.text}>{shop.suA} {shop.suB}</span>
                </div>}
              </div>
            </div>
            <ReservationDetailMap shop={shop} />
            <button onClick={() => this.sendRequest()} style={styles.bottomWrap}>確定預約</button>
          </div>
        </div>
      </div>
    );
  }
}

ReservationFormModal.propTypes = {
  isFormModalOpen: T.bool,
  closeReservationModal: T.func,
  shop: T.object,
  createReservation: T.func,
  customerId: T.number,
};

export default connect(
  state => ({
    isFormModalOpen: state.Reservation.isFormModalOpen,
    shop: state.Reservation.selectedShop,
    customerId: state.Auth.customerId,
  }),
  dispatch => bindActionCreators(ReservationActions, dispatch),
)(radium(ReservationFormModal));



// WEBPACK FOOTER //
// ./containers/Reservations/ReservationFormModal.js